import { Component } from "@angular/core";
import { ResponsiveIconComponent, SvgIcon } from "@components";
import { NotificationContentComponent } from "../../notifications/_shared/notification-content/notification-content.component";
import { TranslateModule } from "@ngx-translate/core";
import { CommonModule } from "@angular/common";
import { AppErrorCode } from "@model";
import { AppErrorService } from "@core";

@Component({
  selector: "app-error-overlay",
  standalone: true,
  imports: [ResponsiveIconComponent, NotificationContentComponent, TranslateModule, CommonModule],
  templateUrl: "./app-error-overlay.component.html",
  styleUrl: "./app-error-overlay.component.scss",
})
export class AppErrorOverlayComponent {
  readonly AppErrorCode = AppErrorCode;
  SvgIcon = SvgIcon;
  error: AppErrorCode | null = null;

  constructor(private _appErrorService: AppErrorService) {
    this._appErrorService.error$.subscribe((error) => {
      this.error = error;
    });
  }

  click(): void {
    window.location.reload();
  }

  setAppFailure(failureCode: AppErrorCode) {
    this.error = failureCode;
  }
}
